export default function ($translate) {
    return {
        KEYS: {
            CONFIRM_HAS_SURVEY_OR_FEEDBACK: 'CONFIRM_HAS_SURVEY_OR_FEEDBACK',
            CONFIRM_HAS_QUIZ: 'CONFIRM_HAS_QUIZ',
            CONFIRM_HAS_CHANGES: 'CONFIRM_HAS_CHANGES',
            CONFIRM_HAS_FORM: 'CONFIRM_HAS_FORM'
        },
        LABELS: {
            CONFIRM_HAS_SURVEY_OR_FEEDBACK: $translate.instant('question.confirm.has_survey_or_feedback_answers'),
            CONFIRM_HAS_QUIZ: $translate.instant('question.confirm.has_quiz_answers'),
            CONFIRM_HAS_CHANGES: $translate.instant('question.confirm.changes'),
            CONFIRM_HAS_FORM: $translate.instant('question.confirm.has_form_related_to_question')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/questions/confirm/index.js